import { render, staticRenderFns } from "./ModalImportarAD.vue?vue&type=template&id=15a54f5d"
import script from "./ModalImportarAD.vue?vue&type=script&lang=js"
export * from "./ModalImportarAD.vue?vue&type=script&lang=js"
import style0 from "./ModalImportarAD.vue?vue&type=style&index=0&id=15a54f5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports